import { type ComponentProps } from 'react';
import { Controller } from 'react-hook-form';
import { get } from 'lodash-es';
import { useReferralFormContext } from '../ReferralFormContext';
import SingleSelectField from '../components/SingleSelectField';

/** omit props that are controlled  by the form provider */
type PartialSingleSelectFieldProps = Omit<
  ComponentProps<typeof SingleSelectField>,
  'onChange' | 'onBlur' | 'value'
>;

interface ControlledSingleSelectFieldProps
  extends PartialSingleSelectFieldProps {
  name: string;
}

/** controlled by react-hook-form context */
const ControlledSingleSelectField = ({
  name,

  ...fieldProps
}: ControlledSingleSelectFieldProps) => {
  const { control, errors } = useReferralFormContext();
  const errorMessage = get(errors, name)?.message;

  return (
    <Controller
      control={control}
      name={name}
      render={({ ref: _ref, value, onBlur, onChange }) => {
        return (
          <SingleSelectField
            {...fieldProps}
            errorMessage={errorMessage}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
          />
        );
      }}
    />
  );
};
export default ControlledSingleSelectField;
